(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const controllers = new Set();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const poseProperties = ['--centec-x', '--centec-depth', '--centec-rx', '--centec-ry', '--centec-rz', '--centec-scale', '--centec-light', '--centec-light-x', '--centec-light-y'];
  const nextFrame = () => new Promise(resolve => requestAnimationFrame(resolve));
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  function initialize(root) {
    const slideshows = root.matches?.('slide-show') ? [root] : Array.from(root.querySelectorAll('slide-show'));
    for (const slideshow of slideshows) {
      if (initialized.has(slideshow) || slideshow.querySelectorAll('slide-show-item').length < 2) continue;
      initialized.add(slideshow);
      slideshow.setAttribute('data-centec-3d-ready', '');
      const list = slideshow.querySelector('.slideshow__slide-list');
      const originalSelect = slideshow.select.bind(slideshow);
      for (const item of slideshow.items) {
        item._untilReady = () => Promise.all(item._getVisibleImages().map(image => new Promise(resolve => {
          if (image.complete) { resolve(); return; }
          let timeout;
          const done = () => {
            clearTimeout(timeout);
            image.removeEventListener('load', done);
            image.removeEventListener('error', done);
            resolve();
          };
          image.addEventListener('load', done, {once: true});
          image.addEventListener('error', done, {once: true});
          timeout = setTimeout(done, 1800);
          image.loading = 'eager';
        })));
      }
      let gesture = null;
      let transaction = null;
      let visualFrame = 0;
      let hoverPoint = null;
      let hoveredInner = null;
      let suppressClickUntil = 0;
      for (const inner of slideshow.querySelectorAll('.slideshow__slide-inner')) {
        const light = document.createElement('span');
        light.className = 'centec-slideshow-light';
        light.setAttribute('aria-hidden', 'true');
        inner.append(light);
      }
      const running = () => slideshow.style.getPropertyValue('--section-animation-play-state') === 'running';
      const resetPose = inner => {
        if (inner) for (const property of poseProperties) inner.style.removeProperty(property);
      };
      const resetHover = () => {
        hoverPoint = null;
        resetPose(hoveredInner);
        hoveredInner = null;
      };
      const camera = width => clamp(Math.round(width * 1.3), 1400, 2400);
      const paint = () => {
        visualFrame = 0;
        if (motion.matches) return;
        if (gesture) {
          const progress = clamp(Math.abs(gesture.dx) / (gesture.width * 0.32), 0, 1);
          const offset = clamp(gesture.dx * 0.7, -gesture.width * 0.32, gesture.width * 0.32);
          const inner = gesture.inner;
          inner.style.setProperty('--centec-x', offset + 'px');
          inner.style.setProperty('--centec-depth', -140 * progress + 'px');
          inner.style.setProperty('--centec-ry', clamp(-gesture.dx / gesture.width * 48, -18, 18) + 'deg');
          inner.style.setProperty('--centec-rz', clamp(-gesture.dx / gesture.width * 2, -1, 1) + 'deg');
          inner.style.setProperty('--centec-scale', String(1 - progress * 0.045));
          inner.style.setProperty('--centec-light', '0.5');
          inner.style.setProperty('--centec-light-x', clamp(50 + gesture.dx / gesture.width * 45, 5, 95) + '%');
          return;
        }
        if (!hoverPoint || transaction) return;
        const item = slideshow.items[slideshow.selectedIndex];
        const inner = item?.querySelector('.slideshow__slide-inner');
        if (!inner) return;
        if (hoveredInner !== inner) {
          resetPose(hoveredInner);
          hoveredInner = inner;
        }
        const rect = slideshow.getBoundingClientRect();
        const x = clamp((hoverPoint.x - rect.left) / rect.width, 0, 1);
        const y = clamp((hoverPoint.y - rect.top) / rect.height, 0, 1);
        slideshow.style.setProperty('--centec-perspective', camera(rect.width) + 'px');
        inner.style.setProperty('--centec-ry', (x - 0.5) * 5 + 'deg');
        inner.style.setProperty('--centec-rx', -(y - 0.5) * 3 + 'deg');
        inner.style.setProperty('--centec-depth', '10px');
        inner.style.setProperty('--centec-scale', '0.995');
        inner.style.setProperty('--centec-light', '0.55');
        inner.style.setProperty('--centec-light-x', x * 100 + '%');
        inner.style.setProperty('--centec-light-y', y * 100 + '%');
      };
      const schedulePaint = () => {
        if (!visualFrame) visualFrame = requestAnimationFrame(paint);
      };
      const finishGesture = () => {
        if (!gesture) return null;
        const ended = gesture;
        gesture = null;
        cancelAnimationFrame(visualFrame);
        visualFrame = 0;
        slideshow.classList.remove('centec-slideshow-3d-dragging');
        resetPose(ended.inner);
        if (ended.captureTarget.hasPointerCapture(ended.pointerId)) ended.captureTarget.releasePointerCapture(ended.pointerId);
        if (ended.wasPlaying) slideshow.startPlayer();
        return ended;
      };
      const cleanupScene = token => {
        token.animations.forEach(animation => animation.cancel());
        token.scene.remove();
        if (transaction !== token) return;
        transaction = null;
        slideshow.classList.remove('centec-slideshow-transitioning');
        if (token.wasPlaying) slideshow.startPlayer();
      };
      const cancelScene = () => {
        if (!transaction) return;
        transaction.skipAnimation = true;
        if (transaction.nativeReady) {
          transaction.animations.forEach(animation => animation.finish());
          cleanupScene(transaction);
        }
      };
      const makePanel = (item, name) => {
        const panel = document.createElement('div');
        panel.className = item.className + ' centec-3d-panel centec-3d-panel--' + name;
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        const sourceStyle = getComputedStyle(item);
        for (const property of ['--heading-color', '--text-color', '--primary-button-background', '--primary-button-text-color', '--section-blocks-alignment', '--section-blocks-overlay-color', '--section-blocks-overlay-opacity', '--image-aspect-ratio', '--mobile-image-aspect-ratio']) {
          panel.style.setProperty(property, sourceStyle.getPropertyValue(property));
        }
        const copy = item.querySelector('.slideshow__slide-inner').cloneNode(true);
        for (const node of [copy, ...copy.querySelectorAll('*')]) {
          node.removeAttribute('id');
          node.removeAttribute('aria-controls');
          node.removeAttribute('reveal');
          node.removeAttribute('reveal-visibility');
          if (node.matches('a, button, input, select, textarea, [tabindex]')) node.setAttribute('tabindex', '-1');
        }
        copy.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.draggable = false; });
        panel.append(copy);
        return panel;
      };
      slideshow.select = async (index, shouldTransition = true, reverseDirection = false) => {
        if (!slideshow.items[index]) return;
        if (transaction) {
          transaction.queued = {index, shouldTransition, reverseDirection};
          return;
        }
        const previousIndex = slideshow.selectedIndex;
        if (!shouldTransition || motion.matches || index === previousIndex) {
          resetHover();
          return originalSelect(index, false, reverseDirection);
        }
        const outgoingItem = slideshow.items[previousIndex];
        const outgoingInner = outgoingItem.querySelector('.slideshow__slide-inner');
        const startTransform = getComputedStyle(outgoingInner).transform;
        const width = Math.max(slideshow.getBoundingClientRect().width, 1);
        const p = camera(width);
        slideshow.style.setProperty('--centec-perspective', p + 'px');
        const direction = reverseDirection || index === (previousIndex - 1 + slideshow.items.length) % slideshow.items.length ? -1 : 1;
        const scene = document.createElement('div');
        scene.className = 'centec-slideshow-scene';
        scene.setAttribute('aria-hidden', 'true');
        scene.setAttribute('inert', '');
        const outgoing = makePanel(outgoingItem, 'outgoing');
        outgoing.style.transform = startTransform;
        scene.append(outgoing);
        const token = {scene, animations: [], wasPlaying: running(), nativeReady: false, skipAnimation: false, queued: null};
        transaction = token;
        resetHover();
        slideshow.pausePlayer();
        list.append(scene);
        slideshow.classList.add('centec-slideshow-transitioning');
        try {
          await originalSelect(index, false, reverseDirection);
          await nextFrame();
          token.nativeReady = true;
          if (transaction !== token || !slideshow.isConnected || token.skipAnimation || motion.matches || slideshow.selectedIndex !== index) return;
          const incoming = makePanel(slideshow.items[index], 'incoming');
          scene.append(incoming);
          const outgoingAnimation = outgoing.animate([
            {transform: startTransform === 'none' ? 'perspective(' + p + 'px) translate3d(0,0,0) rotateY(0deg)' : startTransform, opacity: 1},
            {transform: 'perspective(' + p + 'px) translate3d(' + -direction * width * 0.22 + 'px,0,-160px) rotateY(' + direction * 27 + 'deg) rotateZ(' + -direction * 1.2 + 'deg) scale(0.96)', opacity: 0.95, offset: 0.45},
            {transform: 'perspective(' + p + 'px) translate3d(' + -direction * width * 0.72 + 'px,14px,-360px) rotateY(' + direction * 58 + 'deg) rotateZ(' + -direction * 2.5 + 'deg) scale(0.88)', opacity: 0}
          ], {duration: 900, easing: 'cubic-bezier(0.16,1,0.3,1)', fill: 'both'});
          const incomingAnimation = incoming.animate([
            {transform: 'perspective(' + p + 'px) translate3d(' + direction * width * 0.72 + 'px,20px,-320px) rotateY(' + -direction * 56 + 'deg) rotateZ(' + direction * 2 + 'deg) scale(0.88)', opacity: 1},
            {transform: 'perspective(' + p + 'px) translate3d(' + -direction * width * 0.012 + 'px,0,12px) rotateY(' + direction * 1.5 + 'deg) rotateZ(0deg) scale(1.003)', opacity: 1, offset: 0.72},
            {transform: 'perspective(' + p + 'px) translate3d(0,0,0) rotateY(0deg) rotateZ(0deg) scale(1)', opacity: 1}
          ], {duration: 900, easing: 'cubic-bezier(0.16,1,0.3,1)', fill: 'both'});
          token.animations.push(outgoingAnimation, incomingAnimation);
          await Promise.allSettled(token.animations.map(animation => animation.finished));
        } finally {
          const queued = token.queued;
          cleanupScene(token);
          if (queued && slideshow.isConnected) slideshow.select(queued.index, queued.shouldTransition, queued.reverseDirection);
        }
      };
      slideshow.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
        const item = event.target.closest('slide-show-item');
        if (!item || event.target.closest('button, input, textarea, select, [contenteditable="true"]')) return;
        cancelScene();
        finishGesture();
        resetHover();
        suppressClickUntil = 0;
        const width = Math.max(slideshow.getBoundingClientRect().width, 1);
        slideshow.style.setProperty('--centec-perspective', camera(width) + 'px');
        const captureTarget = event.target.closest('a') || slideshow;
        gesture = {
          pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, dx: 0, moved: false,
          inner: item.querySelector('.slideshow__slide-inner'), width, captureTarget, wasPlaying: running()
        };
        slideshow.pausePlayer();
        slideshow.classList.add('centec-slideshow-3d-dragging');
        captureTarget.setPointerCapture(event.pointerId);
      });
      slideshow.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse') return;
        if (!gesture) {
          if (!event.buttons && event.target.closest('slide-show-item')) {
            hoverPoint = {x: event.clientX, y: event.clientY};
            schedulePaint();
          }
          return;
        }
        if (event.pointerId !== gesture.pointerId) return;
        if (!(event.buttons & 1)) {
          finishGesture();
          return;
        }
        gesture.dx = event.clientX - gesture.startX;
        if (Math.hypot(gesture.dx, event.clientY - gesture.startY) >= 8) gesture.moved = true;
        schedulePaint();
      });
      slideshow.addEventListener('pointerup', event => {
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        const ended = finishGesture();
        const dx = event.clientX - ended.startX;
        const dy = event.clientY - ended.startY;
        if (ended.moved || Math.hypot(dx, dy) >= 8) suppressClickUntil = Date.now() + 500;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        if (dx < 0) slideshow.next();
        else slideshow.previous();
      });
      slideshow.addEventListener('pointerleave', () => {
        if (!gesture) resetHover();
      });
      for (const eventName of ['pointercancel', 'lostpointercapture']) {
        slideshow.addEventListener(eventName, event => {
          if (!gesture || event.pointerId !== gesture.pointerId) return;
          if (gesture.moved) suppressClickUntil = Date.now() + 500;
          finishGesture();
        });
      }
      slideshow.addEventListener('dragstart', event => { if (gesture) event.preventDefault(); });
      slideshow.addEventListener('click', event => {
        if (event.detail === 0 || Date.now() > suppressClickUntil) return;
        suppressClickUntil = 0;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      for (const eventName of ['swipeleft', 'swiperight']) {
        slideshow.addEventListener(eventName, event => {
          const original = event.originalEvent;
          if (original?.pointerType === 'mouse' || original?.type?.startsWith('mouse')) event.stopImmediatePropagation();
        }, true);
      }
      controllers.add({slideshow, reset() {finishGesture(); cancelScene(); resetHover(); cancelAnimationFrame(visualFrame); visualFrame = 0;}});
    }
  }
  motion.addEventListener('change', () => {
    if (motion.matches) controllers.forEach(controller => controller.reset());
  });
  document.addEventListener('shopify:section:unload', event => {
    for (const controller of controllers) {
      if (event.target.contains(controller.slideshow)) {
        controller.reset();
        controllers.delete(controller);
      }
    }
  });
  customElements.whenDefined('slide-show').then(() => {
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
